// Timezone-safe date helpers.
// JavaScript's `Date.toISOString()` converts to UTC, which shifts the day
// by ±1 for users in non-UTC timezones. Similarly, `new Date("YYYY-MM-DD")`
// parses as UTC midnight, then re-renders in local tz (off by a day again).
// These helpers keep dates *local* end-to-end.

/**
 * Format a Date -> "YYYY-MM-DD" using its LOCAL Y/M/D values.
 * Safe for any timezone; returns null if `d` is falsy.
 */
export const toLocalYMD = (d) => {
  if (!d) return null;
  const dt = d instanceof Date ? d : new Date(d);
  if (isNaN(dt.getTime())) return null;
  const y = dt.getFullYear();
  const m = String(dt.getMonth() + 1).padStart(2, "0");
  const day = String(dt.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
};

/**
 * Parse a "YYYY-MM-DD" string into a Date at local midnight.
 * `new Date("2026-07-29")` would return UTC midnight (off by a day in most
 * western timezones); this helper always returns the intended local day.
 */
export const fromYMD = (s) => {
  if (!s) return undefined;
  if (s instanceof Date) return s;
  const str = String(s).slice(0, 10);
  const parts = str.split("-").map(Number);
  if (parts.length < 3 || parts.some(isNaN)) return undefined;
  const [y, m, d] = parts;
  return new Date(y, m - 1, d);
};

/** Today's local date as "YYYY-MM-DD". */
export const todayYMD = () => toLocalYMD(new Date());
